import { render } from "./default-layout.vue?vue&type=template&id=269c77b5"
import script from "./default-layout.vue?vue&type=script&lang=ts"
export * from "./default-layout.vue?vue&type=script&lang=ts"
script.render = render

export default script